'use client'
import {
  createContext,
  CSSProperties,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useState,
} from 'react'
import useTracking from '@/src/hooks/useTracking'

type StateProps<T> = [T, Dispatch<SetStateAction<T>>]

export type PageContextType = {
  topnavHeightState: StateProps<number>
}

const useTopnavHandler = () => {
  const topnavHeightState = useState(0)
  return { topnavHeightState }
}

export const PageContext = createContext<PageContextType | null>(null)

export const PageContextProvider = ({ children }: PropsWithChildren) => {
  useTracking()

  const { topnavHeightState } = useTopnavHandler()

  return (
    <PageContext.Provider value={{ topnavHeightState }}>
      <div
        style={
          {
            '--scroll-margin-top': `${topnavHeightState[0]}px`,
            // disabled hard-limit for block widths for now, but might be needed in the future
            // ...{ maxWidth: 1512, margin: '0 auto' },
          } as CSSProperties
        }>
        {children}
      </div>
    </PageContext.Provider>
  )
}
